import baseApi from "./RootBaseApi";
import { PenaltyType } from "@/types/penalty-config.types";

export interface BookingPolicy {
  free_cancellation_hours?: number;
  penalty_type: PenaltyType | string;
  penalty_value: number;
  min_penalty_amount_eur?: number;
  max_penalty_amount_eur?: number;
}

function hasData<T>(res: unknown): res is { data: T } {
  return (
    typeof res === "object" &&
    res !== null &&
    "data" in (res as Record<string, unknown>)
  );
}

export const SystemConfigService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookingCancellationPolicy: builder.query<BookingPolicy, void>({
      query: () => ({
        url: "/system-config/booking-cancellation-policy",
        method: "GET",
      }),
      transformResponse: (response: { data: BookingPolicy } | BookingPolicy) =>
        hasData<BookingPolicy>(response)
          ? response.data
          : (response as BookingPolicy),
      providesTags: ["PenaltyConfigs"],
    }),

    updateBookingCancellationPolicy: builder.mutation<
      BookingPolicy,
      Partial<BookingPolicy>
    >({
      query: (payload) => ({
        url: "/system-config/booking-cancellation-policy",
        method: "PUT",
        data: payload,
      }),
      invalidatesTags: ["PenaltyConfigs"],
    }),

    getBookingNoShowPolicy: builder.query<BookingPolicy, void>({
      query: () => ({
        url: "/system-config/booking-no-show-policy",
        method: "GET",
      }),
      transformResponse: (response: { data: BookingPolicy } | BookingPolicy) =>
        hasData<BookingPolicy>(response)
          ? response.data
          : (response as BookingPolicy),
      providesTags: ["PenaltyConfigs"],
    }),

    updateBookingNoShowPolicy: builder.mutation<
      BookingPolicy,
      Partial<BookingPolicy>
    >({
      query: (payload) => ({
        url: "/system-config/booking-no-show-policy",
        method: "PUT",
        data: payload,
      }),
      invalidatesTags: ["PenaltyConfigs"],
    }),
  }),
});

export const {
  useGetBookingCancellationPolicyQuery,
  useUpdateBookingCancellationPolicyMutation,
  useGetBookingNoShowPolicyQuery,
  useUpdateBookingNoShowPolicyMutation,
} = SystemConfigService;
